import type { ReactNode } from "react";
import className from "~/kernel/styling/className";

type FormFieldWrapperProps = {
  children: ReactNode;
  fullWidth?: boolean;
};

export default function FormFieldWrapper({
  children,
  fullWidth = true,
}: FormFieldWrapperProps) {
  return (
    <div
      className={className("relative block space-y-2", {
        "w-full": fullWidth,
      })}
    >
      {children}
    </div>
  );
}
